import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '~/store';

import { resetOnLogout } from '~/reducers/common-actions';

export type UnassignedTasksDisplayDateRange = {
    startDate: string;
    endDate: string;
};

export const unassignedTasksDisplayDateRangeSlice = createSlice({
    name: 'unassignedTasksDisplayDateRange',
    initialState: null,
    reducers: {
        setUnassignedTasksDisplayDateRange: (state, action) => {
            return action.payload;
        },
        resetUnassignedTasksDateRange: () => {
            return null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetOnLogout, () => {
            return null;
        });
    }
});

export const {
    setUnassignedTasksDisplayDateRange,
    resetUnassignedTasksDateRange
} = unassignedTasksDisplayDateRangeSlice.actions;

export const selectUnassignedTasksDisplayDateRange = (
    state: RootState
): null | UnassignedTasksDisplayDateRange =>
    state.unassignedTasksDisplayDateRange;

export default unassignedTasksDisplayDateRangeSlice.reducer;
